// client/src/lib/customDexLinkagePref.ts

/**
 * b19-feat-linked-dex: localStorage-backed pref for the "Link custom dexes to
 * base dexes" toggle. When ON (the default), adding to a custom dex (Shiny
 * Perfect or Shiny Lucky) silently ticks the linked base dexes, and removing
 * from a custom dex prompts the user about clearing the linked dexes. When
 * OFF, no auto-tick and no prompt. Mirrors the dexVisibilityStore pattern.
 */

const STORAGE_KEY = "nexus.customDexLinkage.v1";

export const CUSTOM_DEX_LINKAGE_EVENT = "nexus:custom-dex-linkage-changed";

let cache: boolean | null = null;

function loadFromStorage(): boolean {
  if (cache !== null) return cache;
  if (typeof window === "undefined") {
    cache = true;
    return cache;
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    // Default ON: a missing key means the pref has never been set.
    cache = raw === null ? true : raw === "true";
    return cache;
  } catch {
    cache = true;
    return cache;
  }
}

function emit(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CUSTOM_DEX_LINKAGE_EVENT));
}

export function isCustomDexLinkageEnabled(): boolean {
  return loadFromStorage();
}

export function setCustomDexLinkageEnabled(enabled: boolean): void {
  cache = enabled;
  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(STORAGE_KEY, enabled ? "true" : "false");
    } catch {
      // ignore quota errors
    }
  }
  emit();
}

/** Test-only helper: reset the in-memory cache. */
export function __resetCustomDexLinkageCacheForTests(): void {
  cache = null;
}
